import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { StoryWordIndex } from '../slices/story-reading/story-reading.slice.types.ts';

import { selectCurrentLessonTaskStep } from './current-lesson-task-step.selector.ts';

export const selectStepFirstWord = createMemoizedSelector(
  selectCurrentLessonTaskStep,
  ({ step }): StoryWordIndex | undefined => {
    if (step?.index === undefined) return undefined;

    return {
      index: step.index,
      subindex: step.subindex ?? step.startIndex ?? 0,
    };
  }
);
